<ng-container [formGroup]="companyDetailForm">
  <div class="card-body">
    <!-- Header with Logo -->
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mb-0 section-heading">Customer Detail</h2>
        <!-- Company Logo Display (Clearbit or Uploaded) -->
        @if (companyLogo) {
          <div class="header-logo-display">
            <img [src]="companyLogo" alt="Company Logo" class="header-logo-img" (error)="onImageError($event)">
          </div>
        }
      </div>
      @if (!isEdit) {
        <mat-slide-toggle class="b-one-switch" formControlName="is_jobsite">Is Jobsite?</mat-slide-toggle>
      }
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="company_title" class="custom_label">Company Name/Title *</label>
        <input type="text" id="company_title" formControlName="company_title"  class="form-control" placeholder="Company Address Name/Title" name="company_title" >
        <app-validation-error [formGroup]="companyDetailForm" [controlName]="'company_title'" ></app-validation-error>
      </div>

      <!-- Logo Upload Field — collapsed by default, opened from the button
           beside the label. See `showLogoUpload` in the component. -->
      <div class="form-group col-12 logo-upload-group">
        <div class="logo-label-row">
          <label class="custom_label">Add Logo</label>
          <button type="button"
                  class="logo-toggle-btn"
                  [class.is-open]="showLogoUpload"
                  [attr.aria-expanded]="showLogoUpload"
                  aria-controls="customer_logo_upload_panel"
                  [title]="showLogoUpload ? 'Hide logo upload' : 'Upload a logo'"
                  (click)="toggleLogoUpload()">
            <mat-icon>{{ showLogoUpload ? 'close' : 'add_photo_alternate' }}</mat-icon>
          </button>
        </div>
        @if (showLogoUpload) {
          <div id="customer_logo_upload_panel" class="logo-upload-panel">
            <app-attachment
              [module_id]="CONST_MODULE_ID"
              [dragOverlay]="true"
              [dropZoneId]="'customer_logo_upload'"
              (callback)="onLogoAttached($event)"
              (onDelete)="onLogoDeleted($event)">
            </app-attachment>
          </div>
        }
      </div>

      <div class="form-group col-12">
        <label for="company_email" class="custom_label">Company Email </label>

        <input type="email" id="company_email" formControlName="company_email"  class="form-control" placeholder="Company email" name="company_email"    (keydown)="preventSpace($event)" >
        <app-validation-error [formGroup]="companyDetailForm" [controlName]="'company_email'" ></app-validation-error>



      </div>
    </div>

    <app-address [isRequired]="true" appendTo="body" formControlName="main_address" (callback)="initChildForm('main_address', $event.value)" [form]="form" [model]="company_address"></app-address>

    <div class="form-row">
      <div class="form-group col-8">
        <label for="phone" class="custom_label">Phone Number </label>
        <input type="text" id="phone" phoneMask formControlName="phone" (keypress)="omit_special_char($event)" class="form-control" placeholder="Phone Number" name="phone"  >
        <app-validation-error [formGroup]="companyDetailForm" [controlName]="'phone'" [messagePattern]="'Please enter correct phone number'"></app-validation-error>
      </div>
      <div class="form-group col-4">
        <label for="extension" class="custom_label">Extension</label>
        <input type="text" id="extension" formControlName="extension" class="form-control" placeholder="Ext." name="extension" maxlength="10">
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="secondary_phone" class="custom_label">Secondary Phone Number </label>
        <input type="text" id="secondary_phone" phoneMask formControlName="secondary_phone" (keypress)="omit_special_char($event)"   class="form-control" placeholder="Secondary Number" name="secondary_phone">

        <app-validation-error [formGroup]="companyDetailForm" [controlName]="'secondary_phone'" [messagePhoneNumber]="'Invalid Secondary Number'" ></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="fax" class="custom_label">Fax Number</label>
        <input type="text" id="fax" formControlName="fax" (keypress)="omit_special_char($event)"  phoneMask class="form-control" placeholder="Fax Number" name="fax">
        <app-validation-error [formGroup]="companyDetailForm"  [controlName]="'fax'" [messagePhoneNumber]="'Invalid Fax Number'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="website" class="custom_label">Website URL</label>
        <div class="input_with_icon">
          <span class="url-prefix">{{urlPrefix}}</span>
          <input type="url" id="website" (blur)="onBlurWebsiteUrl()" formControlName="website" class="form-control" placeholder="Website URL" name="website" (keydown)="preventSpace($event)">
        </div>
        <app-validation-error [formGroup]="companyDetailForm" [messagePattern]="'Invalid Website URL'" [controlName]="'website'"></app-validation-error>

      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="group" class="custom_label">Company Type(Group) </label>
        <ng-select
          id="group"
          [items]="groups"
          placeholder="Select Group"
          [closeOnSelect]="true"
          formControlName="group"
          bindLabel="name"
          >
        </ng-select>
        <app-validation-error [formGroup]="companyDetailForm" [controlName]="'group'"></app-validation-error>
      </div>

    </div>

    <mat-accordion multi>
      <mat-expansion-panel class="mat-expansion-panel-billing-address-custom" [(expanded)]="billingExpanded" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Billing Address
          </mat-panel-title>
          <mat-panel-description class="address-header-actions">
            <mat-icon
              class="address-status-icon"
              [ngClass]="'address-status-icon--' + getAddressStatus('billing_address')"
              [matTooltip]="getAddressStatus('billing_address') === 'empty' ? 'Billing address not filled' : (getAddressStatus('billing_address') === 'error' ? 'Billing address has  errors' : 'Billing address filled')"
              (click)="$event.stopPropagation()">
              {{ getAddressStatus('billing_address') === 'empty' ? 'remove_circle_outline' : (getAddressStatus('billing_address') === 'error' ? 'error' : 'check_circle') }}
            </mat-icon>
            <button type="button" class="copy-address-btn" (click)="copyCompanyAddressToBillingAddress(); $event.stopPropagation()">
              <i class="fa fa-copy"></i> Copy Address
            </button>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!-- <div class="my-3 d-flex justify-content-md-end">
        <button type="button" class="btn_solid_color p-2" (click)="copyCompanyAddressToBillingAddress()">Copy company address</button>
      </div> -->
      <app-address formControlName="billing_address" [isRequired]="true" appendTo="body" [populateFormOnChanges]="billingAddressChangesFlag" (callback)="initChildForm('billing_address' , $event.value)" [form]="form"  [model]="billing_address"></app-address>
    </mat-expansion-panel>
    @if (companyDetailForm.get('billing_address')?.invalid && companyDetailForm.get('billing_address')?.touched) {
      <div class="error-message">
        <small style="color: red">Billing Address is Required</small>
      </div>
    }
    <mat-expansion-panel class="mat-expansion-panel-billing-address-custom" [(expanded)]="shippingExpanded" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Shipping Address
        </mat-panel-title>
        <mat-panel-description class="address-header-actions">
          <mat-icon
            class="address-status-icon"
            [ngClass]="'address-status-icon--' + getAddressStatus('shipping_address')"
            [matTooltip]="getAddressStatus('shipping_address') === 'empty' ? 'Shipping address not filled' : (getAddressStatus('shipping_address') === 'error' ? 'Shipping address has  errors' : 'Shipping address filled')"
            (click)="$event.stopPropagation()">
            {{ getAddressStatus('shipping_address') === 'empty' ? 'remove_circle_outline' : (getAddressStatus('shipping_address') === 'error' ? 'error' : 'check_circle') }}
          </mat-icon>
          <button type="button" class="copy-address-btn" (click)="copyCompanyAddressToShippingAddress(); $event.stopPropagation()">
            <i class="fa fa-copy"></i> Copy Address
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <!-- <div class="my-3 d-flex justify-content-md-end">
      <button type="button" class="btn_solid_color p-2" (click)="copyCompanyAddressToShippingAddress()">Copy company address</button>
    </div> -->
    <app-address formControlName="shipping_address" appendTo="body" [populateFormOnChanges]="shippingAddressChangesFlag"  (callback)="initChildForm('shipping_address', $event.value)" [form]="form"  [model]="shipping_address" ></app-address>
  </mat-expansion-panel>
</mat-accordion>

<!-- Business Hours Section -->
<h2 class="business-hours-heading mt-4">Business Hours</h2>
<div class="form-row">
  <div class="form-group col-md-6 col-12">
    <label for="start_time" class="custom_label">Start Time</label>
    <ng-select
      id="start_time"
      [items]="timeOptions"
      placeholder="Select Opening Time"
      [closeOnSelect]="true"
      formControlName="start_time"
      [searchable]="true"
      (change)="onStartTimeChange()"
      >
    </ng-select>
    <small class="form-text text-muted">Business opening time</small>
  </div>

  <div class="form-group col-md-6 col-12">
    <label for="end_time" class="custom_label">End Time</label>
    <ng-select
      id="end_time"
      [items]="endTimeOptions"
      placeholder="Select Closing Time"
      [closeOnSelect]="true"
      formControlName="end_time"
      [searchable]="true"
      >
    </ng-select>
    <small class="form-text text-muted">Business closing time</small>
  </div>
</div>

</div>
</ng-container>
